import type { ChatMessage } from "@/types/chat";
import { ChatUserBubble } from "@/components/chat/primitives";

interface UserMessageProps {
  message: ChatMessage;
}

export function UserMessage({ message }: UserMessageProps) {
  return (
    <ChatUserBubble
      content={message.content}
      createdAt={message.created_at}
    />
  );
}
